import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { type MyInfoModuleSpecsFragment } from '../../../../api/fragments/MyInfoModuleSpecs';
import NoItemResult from '../../../../components/results/NoItemResult';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import { useMyInfoSettingsDrawer } from './MyInfoSettingsDrawer';

export type MyInfoSettingsEmptyListProps = {
    module: MyInfoModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasUpdatePermission'>;
};

const MyInfoSettingsEmptyList = ({ module, permissions }: MyInfoSettingsEmptyListProps) => {
    const { t } = useTranslation(['myInfoModuleDetails']);
    const addMyInfoSettingsDrawer = useMyInfoSettingsDrawer(module);
    const { hasUpdatePermission } = permissions;

    return (
        <>
            <NoItemResult
                extra={
                    hasUpdatePermission && (
                        <Button onClick={addMyInfoSettingsDrawer.open} type="primary">
                            {t('myInfoModuleDetails:emptyList.myInfoSettings.noData.action')}
                        </Button>
                    )
                }
                subTitle={t('myInfoModuleDetails:emptyList.myInfoSettings.noData.message')}
            />
            {addMyInfoSettingsDrawer.render()}
        </>
    );
};

export default MyInfoSettingsEmptyList;
